const HCMapStyleDetails = [
    {
        "featureType": "road.highway",
        "stylers": [
            { "weight": 0.5 },
            { "saturation": -30 },
            { "lightness": 46 }
        ]
    },{
        "featureType": "landscape.natural",
        "stylers": [
            { "visibility": "simplified" }
        ]
    },{
        "featureType": "water",
        "stylers": [
            { "visibility": "simplified" },
            { "lightness": 30 }
        ]
    },{
        "featureType": "poi",
        "stylers": [
            { "saturation": -22 },
            { "lightness": 30 },
            { "gamma": 0.9 },
            { "visibility": "on" }
        ]
    },{
        "featureType": "administrative",
        "stylers": [
            { "visibility": "on" },
            { "gamma": 0.54 },
            { "lightness": 45 }
        ]
    },{
        "featureType": "road",
        "stylers": [
            { "lightness": 16 }
        ]
    }
];

export default HCMapStyleDetails;
